var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsMailOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M4 7.141V17.25c0 .41.402.75.889.75H19.11c.487 0 .889-.34.889-.75V7.141l-7.393 5.653a.996.996 0 01-1.214 0L4 7.141zM18.2 6H5.8l6.2 4.741L18.2 6zM4.727 4h14.546C20.775 4 22 5.078 22 6.4v11.2c0 1.322-1.225 2.4-2.727 2.4H4.727C3.225 20 2 18.922 2 17.6V6.4C2 5.078 3.225 4 4.727 4z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMDAzQTVEIiBkPSJNNCA3LjE0MVYxNy4yNWMwIC40MS40MDIuNzUuODg5Ljc1SDE5LjExYy40ODcgMCAuODg5LS4zNC44ODktLjc1VjcuMTQxbC03LjM5MyA1LjY1M2MtLjM1OC4yNzUtLjg1Ni4yNzUtMS4yMTQgMEw0IDcuMTQxek0xOC4yIDZINS44bDYuMiA0Ljc0MUwxOC4yIDZ6TTQuNzI3IDRoMTQuNTQ2QzIwLjc3NSA0IDIyIDUuMDc4IDIyIDYuNHYxMS4yYzAgMS4zMjItMS4yMjUgMi40LTIuNzI3IDIuNEg0LjcyN0MzLjIyNSAyMCAyIDE4LjkyMiAyIDE3LjZWNi40QzIgNS4wNzggMy4yMjUgNCA0LjcyNyA0eiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconsMailOutlined as ReactComponent };